var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssessmentHistory = function SvgAssessmentHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "nonzero",
    d: "M27.675 19.2c-1.7 0-3.3.5-4.8 1.5-2.45 1.7-3.675 4.025-3.675 6.975 0 .45.025.825.075 1.125H3.225c-.4 0-.8-.075-1.2-.225-1.35-.5-2.025-1.5-2.025-3V.825C.05.375.325.1.825 0h7.95c.45.05.725.325.825.825V3h20.025c.4.05.65.3.75.75v3h2.4c.45.05.725.325.825.825V21.6c-1.6-1.55-3.575-2.35-5.925-2.4zM5.55 7.575c.05-.45.325-.725.825-.825H28.05v-1.5H8.775C8.375 5.2 7.6 4.475 7.5 3.975v-1.65H2.325V25.17c0 .675.75 1.425 1.65 1.425.9 0 1.575-.575 1.575-1.425V7.575zm26.02 20.117a3.882 3.882 0 0 0-3.878-3.877 3.882 3.882 0 0 0-3.877 3.877 3.882 3.882 0 0 0 3.877 3.877 3.882 3.882 0 0 0 3.877-3.877zm4.43 7.2c0 .606-.502 1.108-1.108 1.108-.294 0-.58-.121-.779-.329l-2.968-2.96a6.09 6.09 0 0 1-9.545-5.02 6.09 6.09 0 0 1 6.092-6.091 6.09 6.09 0 0 1 5.02 9.545l2.968 2.968c.199.2.32.485.32.78z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssessmentHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assessment-history.4bb9b4a0.svg";
export { ForwardRef as ReactComponent };